import { Component, Element, h, Host, Listen, Prop, State } from '@stencil/core';
import { search } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-parcel-tracker',
  styleUrl: 'pn-parcel-tracker.scss',
})
export class PnSpotlight {
  @Element() hostElement: HTMLElement;
  @Prop() formActionUrl: string = null;
  @Prop() heading: string = 'Track your parcel';
  @Prop() buttonLabel: string = null;
  @Prop() locale: string = 'en';
  @Prop() placeholder: string = 'Enter shipment ID';
  @Prop() inputName: string = 'shipmentID';

  @State() currentWidth = window.innerWidth;

  @Listen('resize', { target: 'window' })
  handleViewportSizeChange(event: any) {
    this.currentWidth = event.target.innerWidth;
  }

  render() {
    return (
      <Host>
        <div class="pn-parcel-tracker__container">
          <form method="GET" action={this.formActionUrl}>
            <h3 class="pn-parcel-tracker__container__heading">{this.heading}</h3>
            <pn-marketweb-input name={this.inputName} placeholder={this.placeholder} />
            <pn-button type="submit" icon={search} tooltip={this.currentWidth < 412 ? this.buttonLabel : null}>
              {this.currentWidth >= 412 && this.buttonLabel}
            </pn-button>
          </form>
        </div>
      </Host>
    );
  }
}
